import clsx from 'clsx';
import { AText, Box } from '@alf/uikit';
import {
  useGetProviderJackpotCoef,
  useSetJackpot
} from '../../../../../../hooks';
import { formatAmount, getCurrencySign } from '../../../../../../utils';
import { JACKPOT_LEVEL_IMAGE_INFO, JACKPOT_TYPES } from '../../constants';

import styles from './index.module.css';

const PateplayJackpotItem = ({
  type,
  jackpotAmounts = {},
  classNames = {},
  currency,
  jackpotIdentifier,
  isInCarouselMoreThanFourAndWrapped = false
}) => {
  const jackpotCoef = useGetProviderJackpotCoef(jackpotIdentifier);

  const { wrapperClassName = '' } = classNames;
  const textRef = useSetJackpot({
    initialValue: Number(jackpotAmounts.currentWinAmount),
    formatTotal: formatAmount,
    step: 0.01 * jackpotCoef,
    delay: 1
  });

  const { levelsImages } = JACKPOT_LEVEL_IMAGE_INFO[jackpotIdentifier];
  const jackpotLevelImage = levelsImages[type];

  const isRedJp = type === JACKPOT_TYPES[jackpotIdentifier].RED;
  const isBlueJp = type === JACKPOT_TYPES[jackpotIdentifier].BLUE;
  const currencySign = getCurrencySign(currency);
  return (
    <Box className={clsx([styles.wrapper, wrapperClassName])} align="center">
      <img
        src={jackpotLevelImage}
        className={clsx([
          styles.lvlBgImage,
          isRedJp && styles.lvlBgImageRedJp,
          isInCarouselMoreThanFourAndWrapped && styles.lvlBgImageFiveAndMore,
          isInCarouselMoreThanFourAndWrapped &&
            isRedJp &&
            styles.lvlBgImageRedJpFiveAndMore
        ])}
        alt="lvl-background"
      />
      <Box
        className={clsx([
          styles.content,
          isRedJp && styles.contentRedJp,
          isBlueJp && styles.contentBlueJp,
          currencySign.length === 1 && styles.contentCentered,
          isInCarouselMoreThanFourAndWrapped && styles.contentFiveAndMore,
          isInCarouselMoreThanFourAndWrapped &&
            isRedJp &&
            styles.contentRedJpFiveAndMore,
          isInCarouselMoreThanFourAndWrapped &&
            isBlueJp &&
            styles.contentBlueJpFiveAndMore
        ])}
      >
        <Box
          className={clsx([
            styles.amountWrapper,
            currencySign.length === 1 && styles.amountWrapperCentered
          ])}
        >
          <Box
            className={clsx([
              styles.amount,
              isInCarouselMoreThanFourAndWrapped && styles.amountFiveAndMore
            ])}
            ref={textRef}
          />
        </Box>
        <Box direction="column">
          {currencySign.split('').map((sign) => (
            <AText
              key={sign}
              className={clsx([
                styles.currency,
                isInCarouselMoreThanFourAndWrapped &&
                  styles.currencyFiveAndMore,
                currencySign.length < 2 && styles.currencySign
              ])}
            >
              {sign}
            </AText>
          ))}
        </Box>
      </Box>
    </Box>
  );
};

export default PateplayJackpotItem;
